
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import { useEffect, useState } from 'react';

const GetInvolvedPage = () => {
  const [bgLoaded, setBgLoaded] = useState(false);
  
  useEffect(() => {
    // Preload the background image
    const img = new Image();
    img.src = '/lovable-uploads/05b31799-5cdd-42a8-b5f4-77021119aa2a.png';
    img.onload = () => setBgLoaded(true);
    
    // Set a fallback timeout in case image loading takes too long
    const timeout = setTimeout(() => setBgLoaded(true), 300);
    
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div 
      className={`min-h-screen transition-opacity duration-500 ${bgLoaded ? 'opacity-100' : 'opacity-0'}`} 
      style={{
        backgroundImage: 'url(/lovable-uploads/05b31799-5cdd-42a8-b5f4-77021119aa2a.png)',
        backgroundSize: '100% auto',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000',
        backgroundAttachment: 'scroll'
      }}
    >
      <div className="bg-black/80 text-white py-16 backdrop-blur-sm">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold text-white">Get Involved</h1>
          <p className="text-xl mt-4 text-gray-300">
            Ways to support and participate in our mission
          </p>
        </div>
      </div>

      <div className="container-custom py-px px-0 my-0 rounded-sm">
        <div className="text-center mb-12">
          <h2 className="section-title text-white">Make a Difference</h2>
          <p className="text-lg max-w-3xl mx-auto text-gray-200 bg-black/70 p-4 rounded-lg backdrop-blur-sm">
            The Ọmọ Odùduwà welcomes supporters from all backgrounds. 
            Whatever your skills, interests, or capacity to contribute, there's a place for you in our movement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-black/80 p-8 rounded-lg backdrop-blur-sm text-white border border-omoduduwa-terracotta/30">
            <h3 className="text-2xl font-bold mb-4 text-omoduduwa-terracotta">Become a Member</h3>
            <p className="mb-4 text-gray-300">
              Join the Ọmọ Odùduwà as an official member to participate in our programs, vote on organizational 
              decisions, and connect with like-minded individuals committed to our cause.
            </p>
            <ul className="list-disc pl-5 mb-6 text-gray-300">
              <li>Access to member-only events and resources</li>
              <li>Voting rights on organizational matters</li>
              <li>Regular updates on our activities and impact</li>
              <li>Networking opportunities with community leaders</li>
            </ul>
            <Link to="/join">
              <Button variant="primary" size="lg" fullWidth>Join Ọmọ Odùduwà</Button>
            </Link>
          </div>

          <div className="bg-black/80 p-8 rounded-lg backdrop-blur-sm text-white border border-omoduduwa-terracotta/30">
            <h3 className="text-2xl font-bold mb-4 text-omoduduwa-terracotta">Make a Donation</h3>
            <p className="mb-4 text-gray-300">
              Support our work financially to help fund our programs, events, and advocacy efforts. 
              Your contribution enables us to expand our reach and deepen our impact.
            </p>
            <ul className="list-disc pl-5 mb-6 text-gray-300">
              <li>One-time or recurring donation options</li>
              <li>Transparent reporting on fund allocation</li>
              <li>Tax-deductible contributions</li>
              <li>Recognition for major donors (optional)</li>
            </ul>
            <Button variant="primary" size="lg" fullWidth>Donate Now</Button>
          </div>
        </div>

        <h2 className="section-subtitle text-center mb-8 text-white">Other Ways to Help</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <div className="bg-black/80 p-6 rounded-lg backdrop-blur-sm text-white border border-omoduduwa-terracotta/20">
            <h3 className="text-xl font-bold mb-3 text-omoduduwa-terracotta">Volunteer Your Time</h3>
            <p className="text-gray-300">
              Contribute your skills and energy to our events, programs, and initiatives. We have opportunities 
              for both regular and occasional volunteers.
            </p>
          </div>
          
          <div className="bg-black/80 p-6 rounded-lg backdrop-blur-sm text-white border border-omoduduwa-terracotta/20">
            <h3 className="text-xl font-bold mb-3 text-omoduduwa-terracotta">Spread the Word</h3>
            <p className="text-gray-300">
              Help amplify our message by sharing our content on social media, telling friends about our work, 
              and inviting others to get involved.
            </p>
          </div>
          
          <div className="bg-black/80 p-6 rounded-lg backdrop-blur-sm text-white border border-omoduduwa-terracotta/20">
            <h3 className="text-xl font-bold mb-3 text-omoduduwa-terracotta">Partner With Us</h3>
            <p className="text-gray-300">
              If you represent an organization with aligned goals, explore collaboration opportunities that 
              can multiply our collective impact.
            </p>
          </div>
        </div>

        <div className="bg-omoduduwa-indigo/90 text-white p-8 rounded-lg text-center backdrop-blur-sm border border-omoduduwa-terracotta/30">
          <h3 className="text-2xl font-bold mb-4 text-white">Have Questions?</h3>
          <p className="text-lg mb-6">
            Contact our team to discuss how you can get involved in a way that matches your interests and availability.
          </p>
          <Link to="/contact">
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-omoduduwa-indigo">
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GetInvolvedPage;
